<script setup lang="ts">
import { formatTitle } from "@augmented/hierarchy/utils";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

const props = defineProps<{
  bookId: string;
  bookTitle: string;
  currentPath: string;
}>();

const breadcrumbs = computed<BreadcrumbItem[]>(() => {
  const items: BreadcrumbItem[] = [
    { label: "Catalog", to: "/books" },
    { label: props.bookTitle, to: `/book/${props.bookId}` },
  ];

  if (props.currentPath) {
    const parts = props.currentPath.split("/");
    let accumulatedPath = "";

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (!part) continue;
      accumulatedPath += (accumulatedPath ? "/" : "") + part;

      // Format the part as a title
      const label = formatTitle(part);

      // Last item has no link
      if (i === parts.length - 1) {
        items.push({ label });
      } else {
        items.push({ label, to: `/book/${props.bookId}/${accumulatedPath}` });
      }
    }
  }

  return items;
});
</script>

<template>
  <nav
    class="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400 mb-4"
  >
    <template v-for="(item, index) in breadcrumbs" :key="index">
      <NuxtLink
        v-if="item.to"
        :to="item.to"
        class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
      >
        {{ item.label }}
      </NuxtLink>
      <span v-else class="text-gray-900 dark:text-white font-medium">
        {{ item.label }}
      </span>

      <UIcon
        v-if="index < breadcrumbs.length - 1"
        name="i-heroicons-chevron-right"
        class="w-4 h-4 text-gray-400"
      />
    </template>
  </nav>
</template>
